var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2Havalandirma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "air-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 155.6 106.5"
    },
    xmlSpace: "preserve",
    viewBox: "39.85 15.35 75.8 75.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \n  \t.st0{fill:none;} \n\t.st1{fill:none;stroke:#000000;stroke-width:2.7;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Layer_2_1_",
    className: "st0 svg-elem-1",
    d: "M86.4,83.2c0.8,3.4-1.8,6.6-5.2,6.6h-6.8c-3.5,0-6-3.2-5.2-6.6l5.1-21.5  c1.1,0.5,2.3,0.7,3.5,0.7s2.5-0.2,3.5-0.7L86.4,83.2L86.4,83.2z M41.2,49.8v6.8c0,3.5,3.2,6,6.6,5.2l21.5-5.1  c-0.5-1.1-0.7-2.3-0.7-3.5s0.2-2.5,0.7-3.5l-21.5-5.1C44.4,43.8,41.2,46.4,41.2,49.8L41.2,49.8z M79,16.7h-4.6  c-3.5,0-6,3.2-5.2,6.6l5.1,21.5c1.1-0.5,2.3-0.7,3.5-0.7c1.3,0,2.5,0.2,3.5,0.7l5.1-21.5c0.8-3.4-1.8-6.6-5.2-6.6L79,16.7L79,16.7z   M114.3,52v-2.2c0-3.5-3.2-6-6.6-5.2l-21.5,5.1c0.5,1.1,0.7,2.3,0.7,3.5s-0.2,2.5-0.7,3.5l21.5,5.1c3.4,0.8,6.6-1.8,6.6-5.2V52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    className: "nt-44-st0 svg-elem-2",
    d: "M86.3,56.8c-0.9,2.2-2.7,4-5,5c-1.1,0.5-2.3,0.7-3.5,0.7c-1.3,0-2.5-0.2-3.5-0.7  c-2.2-0.9-4-2.7-5-5c-0.5-1.1-0.7-2.3-0.7-3.5s0.2-2.5,0.7-3.5c0.9-2.2,2.7-4,5-5c1.1-0.5,2.3-0.7,3.5-0.7c1.3,0,2.5,0.2,3.5,0.7  c2.2,0.9,4,2.7,5,5c0.5,1.1,0.7,2.3,0.7,3.5S86.7,55.7,86.3,56.8z M81.9,53.2c0-2.3-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2  s1.9,4.2,4.2,4.2S81.9,55.5,81.9,53.2L81.9,53.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Layer_4",
    className: "st0 svg-elem-3",
    cx: 77.8,
    cy: 53.2,
    r: 4.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-4",
    d: "M86.3,49.7c0.5,1.1,0.7,2.3,0.7,3.5s-0.2,2.5-0.7,3.5c-0.9,2.2-2.7,4-5,5c-1.1,0.5-2.3,0.7-3.5,0.7  c-1.3,0-2.5-0.2-3.5-0.7c-2.2-0.9-4-2.7-5-5c-0.5-1.1-0.7-2.3-0.7-3.5s0.2-2.5,0.7-3.5c0.9-2.2,2.7-4,5-5  c1.1-0.5,2.3-0.7,3.5-0.7c1.3,0,2.5,0.2,3.5,0.7C83.5,45.7,85.3,47.5,86.3,49.7L86.3,49.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1 svg-elem-5",
    cx: 77.8,
    cy: 53.2,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-6",
    d: "M74.2,44.8L74.2,44.8l-5.1-21.5c-0.8-3.4,1.8-6.6,5.2-6.6h2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-7",
    d: "M81.3,44.8L81.3,44.8l5.1-21.5c0.8-3.4-1.8-6.6-5.2-6.6h-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-8",
    d: "M81.3,61.7L81.3,61.7l5.1,21.5c0.8,3.4-1.8,6.6-5.2,6.6H79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-9",
    d: "M74.2,61.7L74.2,61.7l-5.1,21.5c-0.8,3.4,1.8,6.6,5.2,6.6H79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-10",
    d: "M86.2,49.7L86.2,49.7l21.5-5.1c3.4-0.8,6.6,1.8,6.6,5.2V52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-11",
    d: "M86.2,56.8L86.2,56.8l21.5,5.1c3.4,0.8,6.6-1.8,6.6-5.2V52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-12",
    d: "M69.3,56.8L69.3,56.8l-21.5,5.1c-3.4,0.8-6.6-1.8-6.6-5.2v-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-13",
    d: "M69.3,49.7L69.3,49.7l-21.5-5.1c-3.4-0.8-6.6,1.8-6.6,5.2v4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-14",
    d: "M106.4,39.4c-3.1-6.3-8.1-11.4-14.3-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-15",
    d: "M88.3,32.3c4.6,2.3,8.3,6.1,10.6,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-16",
    d: "M63.9,24.6c-6.3,3.1-11.4,8.1-14.6,14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-17",
    d: "M56.8,42.7c2.3-4.6,6.1-8.3,10.7-10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-18",
    d: "M49.1,67.1c3.1,6.3,8.1,11.4,14.3,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-19",
    d: "M67.2,74.2c-4.6-2.3-8.3-6.1-10.6-10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-20",
    d: "M91.6,81.9c6.3-3.1,11.4-8.1,14.6-14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-21",
    d: "M98.7,63.8c-2.3,4.6-6.1,8.3-10.7,10.6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Havalandirma);
export default __webpack_public_path__ + "static/media/2.havalandirma.111b7b2465709bb7556ee7c0acd10e61.svg";
export { ForwardRef as ReactComponent };